// extracted by mini-css-extract-plugin
export var body = "_1z-8";
export var button = "_1z-0";
export var closeButton = "_1z-5";
export var content = "_1z-3";
export var empty = "_1z-f";
export var grid = "_1z-c";
export var header = "_1z-4";
export var icon = "_1z-1";
export var option = "_1z-d";
export var optionSelected = "_1z-e";
export var overlay = "_1z-2";
export var searchIcon = "_1z-a";
export var searchInput = "_1z-b";
export var searchWrapper = "_1z-9";
export var title = "_1z-6";
export var visuallyHidden = "_1z-7";